import React from 'react'
import {Editor} from '@tinymce/tinymce-react'
import {useSelector} from "react-redux";
import axios from 'axios'

export default function TextEditor(props) {
  const accountOrganizationMediaFileUploadUrl = useSelector((state) => state.accountOrganizationMediaFileUploadUrl)
  const text_editor_settings = useSelector((state) => state.text_editor_settings)
  const rawHtmlEnabled = useSelector((state) => state.textEditorSettings?.rawHtmlEnabled)
  const tinyMceApiKey = useSelector((state) => state.tinyMceApiKey)
  const tinyMceTokenUrl = useSelector(state => state.tinyMceTokenUrl)
  const accountOrganization = useSelector(state => state.accountOrganization)

  const handleEditorChange = (content, editor) => {
    if (props.onDataChanged) {
      const data = {
        html: content
      }
      props.onDataChanged(data)
    }
  }

  let additionalPlugins = []

  if (rawHtmlEnabled) {
    additionalPlugins.push("code")
  }

  return <div>
    <Editor
      initialValue={props.initialEditorState?.html || ""}
      apiKey={tinyMceApiKey}

      init={{
        height: 500,
        // menubar: false,
        setup: editor=> {
          props.setEditor ? props.setEditor(editor) : null
          return editor
        },
        plugins: [
          'advlist autolink lists link image charmap anchor',
          'searchreplace visualblocks fullscreen',
          'insertdatetime table paste image',
          'tinydrive',
          ...additionalPlugins
        ],
        //
        tinydrive_token_provider: '/jwt',
        tinydrive_token_provider: function (success, failure) {
            axios.post(tinyMceTokenUrl).then((response) => {
              if(response?.data?.status == "OK") {
                success({ token: response.data.token });  
              } else {
                failure('Could not create a jwt token')
              }
            })
        },
        valid_children : '+body[style]',
        extended_valid_elements:"style,link[href|rel]",
        custom_elements:"style,link,~link",
        default_link_target:"_blank",
        target_list: false,
        image_class_list: [
          {title: "Default", value: ""},
          {title: "Responsive", value: "img-fluid"}
        ],
        //images_upload_url: accountOrganizationMediaFileUploadUrl,
        toolbar:
          'image | undo redo | formatselect | bold italic backcolor | \
          alignleft aligncenter alignright alignjustify | \
          bullist numlist outdent indent | removeformat',
      }}
      onEditorChange={handleEditorChange}
      />
  </div>;
}
